import { select } from 'redux-saga/effects';

import * as actions from '../state';

// eslint-disable-next-line import/prefer-default-export
export function* setTitle(boardName) {
  const name = yield select((state) => actions.selectConfig(state, 'PORTAL_ANALYTICS_FEATURE_NAME')) || 'SNAPanalytics';

  let title = '';

  if (boardName && name) {
    title = `${boardName} - ${name}`;
  } else if (boardName) {
    title = boardName;
  } else if (name) {
    title = name;
  }

  let titleElem = document.getElementsByTagName('title')[0];
  if (!titleElem) {
    titleElem = document.createElement('title');
    document.getElementsByTagName('head')[0].appendChild(titleElem);
  }

  titleElem.innerText = title;
}
